module.exports = __webpack_public_path__ + "static/media/yoda.d41c0fc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/yoda.jpg
// module id = 40
// module chunks = 0